<!-- Dataview with filtering and pagination inside -->
<p-dataView
    #dataView
    class="dataview"
    [ngClass]="{ 'dataview_without-content': state != 'loaded' }"
    [value]="customers"
    filterBy="fl,pelephone,comments"
    [layout]="layoutType"
    [paginator]="state != 'loading'"
    [rows]="rows"
    [alwaysShowPaginator]="false"
    paginatorPosition="bottom"
    (onPage)="onPageChange()"
    (wheel)="onScroll()"
    [lazy]="true"
    [totalRecords]="totalRecords"
    (onLazyLoad)="loadCustomersLazyAll($event)"
>
    <!-- Dataview header that contains filtering -->
    <p-header>
        <div class="dataview__header">
            <div class="dataview__options">
                <div class="dataview__buttons">
                    <span class="dataview__layout-button"></span>
                    <button class="button button_with-icon button_theme_main" [disabled]="isDisabled(7)" (click)="addNewClient()">
                        הוסף לקוח/ה
                        <i class="fa-regular fa-plus"></i>
                    </button>
                </div>

                <div class="dataview__filter">
                    <div
                        class="input-wrapper input-wrapper_high input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select dataview__select-wrapper"
                        [ngClass]="{ 'input-wrapper_disabled': isFiltersDisabled() }"
                    >
                        <span class="input-label">סנן תגיות</span>
                        <select class="input" [(ngModel)]="categoryOption" [disabled]="isFiltersDisabled()" (change)="filterDataCustomers()">
                            <option *ngFor="let category of customCategories">{{ category.custCategoryName }}</option>
                        </select>
                    </div>
                    <!-- (change)="filterDataCustomers()" -->
                    <div
                        class="input-wrapper input-wrapper_high input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select dataview__select-wrapper"
                        [ngClass]="{ 'input-wrapper_disabled': isFiltersDisabled() }"
                    >
                        <span class="input-label">סנן סיווגים</span>
                        <select class="input" [(ngModel)]="classificationOption" [disabled]="isFiltersDisabled()" (change)="filterDataCustomers()">
                            <option *ngFor="let classification of customClassificationData">
                                {{ classification }}
                            </option>
                        </select>
                    </div>

                    <div
                        class="input-wrapper input-wrapper_high input-wrapper_with-label input-wrapper_with-icon input-wrapper_type_select dataview__select-wrapper"
                        [ngClass]="{ 'input-wrapper_disabled': isFiltersDisabled() }"
                    >
                        <span class="input-label">סנן לקוחות</span>
                        <select class="input" [(ngModel)]="sexOption" [disabled]="isFiltersDisabled()" (change)="filterDataCustomers()">
                            <option *ngFor="let sex of sexData">{{ sex }}</option>
                        </select>
                    </div>

                    <div
                        class="input-wrapper input-wrapper_high dataview__search-wrapper"
                        [ngClass]="{ 'input-wrapper_disabled': isFiltersDisabled() }"
                    >
                        <input
                            class="input"
                            [(ngModel)]="filterValue"
                            type="search"
                            inputmode="search"
                            placeholder="חפש לפי שם, טלפון או הערה"
                            [disabled]="isFiltersDisabled()"
                            autocomplete="off"
                            (input)="filterByInput()"
                        />
                    </div>
                </div>
            </div>

            <div class="dataview__total" *ngIf="state == 'loaded'">
                <!-- <span *ngIf="!isFiltered()">{{ customers.length }} לקוחות במאגר</span> -->
                <!-- <span *ngIf="isFiltered()">נמצאו {{ customers.length }} לקוחות מתוך {{ totalCustomers }}</span> -->

                <!-- Lazy loading -->
                <span *ngIf="!isFilteredLazy()">{{ totalRecordsAll }} לקוחות במאגר</span>
                <span *ngIf="isFilteredLazy()">נמצאו {{ totalRecords }} לקוחות מתוך {{ totalRecordsAll }}</span>
            </div>
        </div>
    </p-header>

    <ng-template let-customer pTemplate="gridItem">
        <div class="dataview__card">
            <div class="card__header">
                <div class="card__buttons">
                    <button class="card__button" (click)="toggleSubMenu($event, menu, customer, false)">
                        <i class="card__icon card__more-icon fa-solid fa-ellipsis-vertical"></i>
                    </button>
                    <button class="card__button card__button_mobile" (click)="toggleSubMenu($event, menu, customer, true)">
                        <i class="card__icon card__more-icon fa-solid fa-ellipsis-vertical"></i>
                    </button>
                    <p-menu #menu class="card__menu action-list" [model]="items" [popup]="true"></p-menu>

                    <div class="card__contacts">
                        <button
                            class="card__button"
                            [ngClass]="{ card__button_disabled: isBlurred(6) || !(customer && customer.pelephone) }"
                            (click)="openDialog(customer)"
                        >
                            <img class="card__icon" src="/assets/img/chat-dots.svg" alt="chat-dots" />
                        </button>

                        <a
                            class="card__button"
                            [ngClass]="{ card__button_disabled: isBlurred(4) || !(customer && customer.pelephone) }"
                            href="{{ getWhatsAppLink(customer) }}"
                            target="_blank"
                        >
                            <img src="/assets/img/whatsapp.svg" alt="icon-whatsapp" />
                        </a>

                        <a class="card__phone" href="tel:{{ customer.pelephone }}">
                            {{ customer.pelephone }}
                        </a>
                    </div>
                </div>

                <div class="card__client" (click)="redirectToEditScreen(customer.customerId)">
                    <span class="card__name" dir="auto">
                        {{ customer.fl }}
                    </span>

                    <span *ngIf="customer.age > 0 || customer.sex == 2 || customer.sex == 3" class="card__info">
                        (<span *ngIf="customer.age > 0">{{ customer.age }}</span>
                        <!-- <span *ngIf="customer.sex == 1">לא מוגדר</span> -->
                        <span *ngIf="customer.age > 0 && (customer.sex == 2 || customer.sex == 3)">, </span>
                        <span *ngIf="customer.sex == 2">אישה</span>
                        <span *ngIf="customer.sex == 3">גבר</span>)
                    </span>
                </div>
            </div>

            <div class="card__content" (click)="redirectToEditScreen(customer.customerId)">
                <div class="card__details">
                    <div *ngIf="customer.birthDay || customer.debt" class="card__badges">
                        <div *ngIf="customer.birthDay" class="card__badge badge_birthday">
                            <span class="badge__text">יום הולדת החודש</span>
                            <i class="badge__icon fa-regular fa-cake-candles"></i>
                        </div>

                        <div *ngIf="customer.debt" class="card__badge badge_debt">
                            <span class="badge__text">לקוח עם חוב</span>
                            <i class="badge__icon fa-duotone fa-coins"></i>
                        </div>
                    </div>

                    <p *ngIf="customer.comments" class="card__text custom-scrollbar">{{ customer.comments }}</p>
                    <p *ngIf="!customer.comments" class="card__text card__text_empty">אין עדיין הערות בכרטיס הלקוח/ה</p>
                </div>

                <div class="card__image-wrapper">
                    <span class="card__vip fa-solid fa-heart" [ngClass]="{ card__vip_active: isVIPCustomer(customer) }"></span>
                    <img class="card__image" [src]="getClientImageSrc(customer)" (error)="clearImagePath(customer.customerId)" alt="Client picture" />
                </div>
            </div>

            <div class="card__footer">
                <button
                    class="card__button card__button_mobile"
                    [ngClass]="{ card__button_disabled: isBlurred(6) || !(customer && customer.pelephone) }"
                    (click)="openDialog(customer)"
                >
                    <img class="card__icon" src="/assets/img/chat-dots.svg" alt="chat-dots" />
                </button>

                <a
                    class="card__button card__button_mobile"
                    [ngClass]="{ card__button_disabled: isBlurred(4) || !(customer && customer.pelephone) }"
                    href="{{ getWhatsAppLink(customer) }}"
                    target="_blank"
                >
                    <img src="assets/img/whatsapp.svg" />
                </a>

                <a class="card__phone" href="tel:{{ customer.pelephone }}">
                    {{ customer.pelephone }}
                </a>
            </div>
        </div>
    </ng-template>
</p-dataView>

<button class="button button_icon-only button_theme_main add-button" [disabled]="isDisabled(7)" (click)="addNewClient()">
    <i class="fa-regular fa-plus"></i>
</button>

<div *ngIf="state == 'loading'" class="dataview__loader-wrapper">
    <span class="dataview__loader-text">טוען מאגר לקוחות...</span>
    <span class="dataview__loader"></span>
</div>

<div *ngIf="state == 'noclients'" class="dataview__empty-wrapper">
    <h3 class="dataview__empty-title">אין עדיין לקוחות במאגר</h3>
    <span class="dataview__empty-text">לחצו על כפתור הוסף לקוח/ה כדי להוסיף לקוחות</span>
    <span class="dataview__empty-image"></span>
</div>

<div *ngIf="state == 'noresults'" class="dataview__empty-wrapper dataview__empty-wrapper_no-result">
    <h3 class="dataview__empty-title">
        לא מצאנו תוצאות לחיפוש<span *ngIf="filterValue"> `{{ filterValue }}`</span>
    </h3>
    <span class="dataview__empty-text">שימו לב שאפשר לחפש לפי שם, טלפון ואפילו הערה…</span>
    <span class="dataview__empty-image"></span>
</div>

<p-dialog class="dialog__panel" [(visible)]="isDialogVisible" [resizable]="false" [draggable]="false" [modal]="true" [dismissableMask]="true">
    <h3 class="dialog__title">שליחת סמס ללקוח</h3>

    <div class="input-wrapper" [ngClass]="{ 'input-wrapper_with-details': isDialogErrorVisible, 'input-wrapper_error': isDialogErrorVisible }">
        <input class="input" #smsInput [(ngModel)]="smsText" type="text" autocomplete="off" />
        <span class="input-details">השדה הזה לא יכול להיות ריק</span>
    </div>

    <div class="dialog__buttons">
        <button class="button button_size_small button_theme_main" (click)="hideDialog(true)">לשלוח</button>
        <button class="button button_size_small button_theme_gray-line" (click)="hideDialog(false)">ביטול</button>
    </div>
</p-dialog>

<p-dialog
    [ngClass]="{ 'custom-dialog': isCardMenuOpened }"
    styleClass="modal modal_type_menu modal_card-menu"
    [(visible)]="isCardMenuOpened"
    header="פעולות נוספות ללקוח"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
    transitionOptions="0ms"
>
    <button
        *ngFor="let item of items"
        class="menu-button {{ item.icon }} button button_with-icon"
        (click)="item.command()"
        [disabled]="item.disabled"
    >
        {{ item.label }}
    </button>
</p-dialog>

<p-dialog
    [ngClass]="{ 'custom-dialog': isDeletingCardModalVisible }"
    styleClass="modal modal_type_confirm"
    [(visible)]="isDeletingCardModalVisible"
    header="מחיקת לקוח/ה"
    [modal]="true"
    [resizable]="false"
    [draggable]="false"
>
    <span class="modal__text">האם אתם בטוחים במחיקת לקוח/ה?</span>
    <div class="modal__footer">
        <button class="button button_size_small button_theme_main" (click)="closeDeletingCardModal()">לא למחוק</button>
        <button class="button button_size_small button_theme_gray-line" (click)="deleteCustomerCard()">למחוק</button>
    </div>
</p-dialog>

<p-messages class="messages"></p-messages>
